"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestState = exports.questConditionMatches = exports.getQuestConditionId = exports.QuestConditionType = exports.QuestRewardType = void 0;
var QuestRewardType;
(function (QuestRewardType) {
    QuestRewardType["Item"] = "item";
    QuestRewardType["Coins"] = "coins";
})(QuestRewardType || (exports.QuestRewardType = QuestRewardType = {}));
var QuestConditionType;
(function (QuestConditionType) {
    QuestConditionType["Kill"] = "kill";
})(QuestConditionType || (exports.QuestConditionType = QuestConditionType = {}));
/**
 * Gets the id of the quest conditions
 */
function getQuestConditionId(q) {
    return "".concat(q.type, "-").concat(q.creatureConfigId);
}
exports.getQuestConditionId = getQuestConditionId;
/**
 * Checks if two quest conditions matches
 */
function questConditionMatches(q1, q2) {
    return getQuestConditionId(q1) === getQuestConditionId(q2);
}
exports.questConditionMatches = questConditionMatches;
var QuestState;
(function (QuestState) {
    /**
     * Quest is accepted
     */
    QuestState["Active"] = "active";
    /**
     * All the quest requirements are achieved
     * but have not been handed in
     */
    QuestState["Achieved"] = "achieved";
    /**
     * Quest is turned in and reward given
     */
    QuestState["Completed"] = "completed";
})(QuestState || (exports.QuestState = QuestState = {}));
